import {connect} from '@modifi/redux'
import {compose} from 'ramda'

import {downloadInvoice} from '../../utils'
import InvoiceList from './InvoiceList'

const mapStateToProps = state => ({
  downloadInvoice: downloadInvoice(state),
})
const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(InvoiceList)
